import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { MobileDateRangePicker } from "@mui/x-date-pickers-pro/MobileDateRangePicker";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import StudentsSelector from "../../components/faculty/report/StudentsSelector";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import {
  getCommServiceTypes,
  saveCommService,
} from "../../services/CommServiceService";
import SubTitle from "../SubTitle";
import { getSchoolStudents } from "../../services/UserService";
import { hasError } from "../../services/ServiceHelper";
import { showError } from "../../components/ATPDialogs";

const CommServiceSingleDialog = ({
  school,
  jwt,
  dialogOpen,
  setDialogOpen,
  dialogClose,
  onSave,
}) => {
  const [_csLoading, setCsLoading] = useState(false);
  const [_commServiceTypes, setCommServiceTypes] = useState([]);
  const [_selectedStudents, setSelectedStudents] = useState([]);
  const [_commServiceType, setCommServiceType] = useState("XX");
  const [_hours, setHours] = useState("XX");
  const [_minutes, setMinutes] = useState("0");
  const [_dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const [_commServiceDescription, setCommServiceDescription] = useState("");

  useEffect(() => {
    initStudents();
    initTypes();
  }, []);

  const initTypes = () => {
    setCsLoading(true);
    getCommServiceTypes(school, jwt).then((results) => {
      setCsLoading(false);
      setCommServiceTypes(results.data);
    });
  };

  const initStudents = () => {
    setCsLoading(true);
    getSchoolStudents(school, jwt).then((results) => {
      setCsLoading(false);
      // setCommServiceTypes(results.data);
    });
  };

  const handleClose = () => {
    setDialogOpen(false);
    if (dialogClose) {
      dialogClose();
    }
  };

  const handleChangeType = (event) => {
    const eid = event.target.value;
    setCommServiceType(eid);
  };

  const handleChangeHours = (event) => {
    setHours(event.target.value);
  };

  const handleChangeMinutes = (event) => {
    setMinutes(event.target.value);
  };

  const doSaveCommService = () => {

    if (_commServiceType === "XX") {
      alert("Please select a Service Type.");
      return;
    }

    if (_commServiceDescription === "") {
      alert("Please enter a Description.");
      return;
    }

    if (_hours === "XX") {
      alert("Please select Hours.");
      return;
    }

    if (_minutes === "XX") {
      alert("Please select Minutes.");
      return;
    }


    const dateStart = _dateRange[0].format("YYYY-MM-DD");
    const dateEnd = _dateRange[1].format("YYYY-MM-DD");

    const studentEids = [];
    for (const entry of _selectedStudents) {
      studentEids.push(entry.value);
    }

    setCsLoading(true);

    saveCommService(
      school,
      jwt,
      _commServiceType,
      dateStart,
      dateEnd,
      _commServiceDescription,
      _hours,
      _minutes,
      "NONE",
      "",
      "",
      "",
      0,
      "",
      null,
      studentEids
    ).then((result) => {
      setCsLoading(false);
      if (hasError(result)) {
        setDialogOpen(false);
        showError("Unable to Add Service Op", result.detail);
        return;
      }

      setHours("XX");
      setMinutes("0");
      setDateRange([dayjs(), dayjs()]);
      setSelectedStudents([]);
      if (onSave) {
        onSave();
      }
    });
  };

  const handleChangeDateRange = (value) => setDateRange(value);


  return (
    <Dialog onClose={handleClose} open={dialogOpen}>
      <DialogTitle>Manage Service Ops</DialogTitle>

      <DialogContent>
        <Box sx={{ boxShadow: 1, p: 1, mt: 1 }}>
          <SubTitle text="New Entries" />

          <StudentsSelector
            school={school}
            jwt={jwt}
            onChange={(studentEids) => setSelectedStudents(studentEids)}
            selectedStudents={_selectedStudents}
          />

          <InputLabel sx={{ mt: 1 }}>* Service Date</InputLabel>
          <MobileDateRangePicker
            value={_dateRange}
            sx={{ mt: 1, mb: 2 }}
            onChange={handleChangeDateRange}
          />          


          <InputLabel sx={{ mt: 1 }}>* Service Type:</InputLabel>
          <Select
            onChange={handleChangeType}
            value={_commServiceType}
            fullWidth
            size="small"
          >
            <MenuItem value="XX">-- SELECT --</MenuItem>
            {_commServiceTypes.map((type) => (
              <MenuItem key={type.eid} value={type.eid}>
                {type.name}
              </MenuItem>
            ))}
          </Select>

          <InputLabel sx={{ mt: 1 }}>* Description</InputLabel>
          <TextField
            margin="dense"
            type="text"
            fullWidth
            size="small"
            onChange={(evt) => setCommServiceDescription(evt.target.value)}
            placeholder="Required Field"
            value={_commServiceDescription}
            sx={{ mt: 0 }}
          />

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputLabel sx={{ mt: 1 }}>* Hours Spent</InputLabel>
              <Select
                onChange={handleChangeHours}
                value={_hours}
                fullWidth
                size="small"
              >
                <MenuItem value="XX">-- HOURS --</MenuItem>
                {Array.from(Array(76), (e, i) => {
                  return (
                    <MenuItem key={i} value={i}>
                      {i}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
            <Grid item xs={6}>
              <InputLabel sx={{ mt: 1 }}>* Minutes Spent</InputLabel>
              <Select
                onChange={handleChangeMinutes}
                value={_minutes}
                fullWidth
                size="small"
              >
                <MenuItem value="0">0</MenuItem>
                <MenuItem value="15">15</MenuItem>
                <MenuItem value="30">30</MenuItem>
                <MenuItem value="45">45</MenuItem>
              </Select>
            </Grid>
          </Grid>

          <br />
        </Box>

        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={_csLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
        <Button variant="contained" onClick={doSaveCommService}>
          Save Service Op
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommServiceSingleDialog;
